module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-right-simple-grey-c64b3185ea0e9da4a9fdd714bfed42fa.svg";